import React from 'react';
import Select from 'Components/UI/BehavioralFormElement/Select';

const metaSelect = (resourceName, fieldName, meta) => {
  const MetaSelect = ({ ...rest }) => {
    let options = [];
    const field = meta.template.find(f => f.name === fieldName);
    if (field && Array.isArray(field.options)) {
      options = field.options.map(option => ({
        id: option.id,
        value: option.prompt,
      }));
    }
    return <Select {...rest} options={options} />;
  };

  return MetaSelect;
};

const HouseholdStatusSelect = meta => metaSelect('household', 'statusId', meta);

export { HouseholdStatusSelect }; // eslint-disable-line
